import axios from "axios"
import { getToken } from "../../../MFEs/Monetization-Sdk/src/helper"
import { publishDiscountData } from "../../Events/monetisation.events";
import logger from "../../../logger";
import { getStorageItem } from "../../../helpers/storageManager";

let xApikey = window?.xApiKey
let apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
let site = window?.app_data?.site?.siteInternalName
let countryCode = window?.app_data?.countryCode || "IN"
export const validateSubscriptionOfferCodeByPlanId = async (payload) => {
  try {
    let token = await getToken(token => { return token })
    const response = await axios({
      method: 'POST',
      url: `${apiBaseUrl}/v3/offer/validate`,
      params: { site: site },
      data: payload,
      headers: {
        Authorization: token,
        'x-api-key': xApikey
      }
    })
    return {
      isError: false,
      data: response.data
    }
  } catch (error) {
    return {
      isError: true,
      code: (error.response && error.response.data && error.response.data.code),
      error: (error.response && error.response.data && error.response.data.message) || 'An error occuredd. Try again later'
    }
  }
}

export var getDiscountPrice = async (data) => {
  let token = await getToken(token => { return token })
  let planId = data?.id
  let transactionData = getStorageItem('transactionData')
  let transactionType = transactionData?.purchaseType === "Buy" ? "PURCHASE" : transactionData?.purchaseType?.toUpperCase()
  let params = {
    countryCode: countryCode,
    planId,
    site: site,
    offerCode: data?.offerCode || null,
    transactionType: data?.transactionType || transactionType
  }
  return axios({
    method: 'GET',
    url: `${apiBaseUrl}/subscription/calculate/discount`,
    params: params,
    headers: {
      Authorization: token,
      'x-api-key': xApikey
    }
  }).then((res) => {
    let data = {
      appliedOfferCode: res?.data?.appliedOfferCode,
      amount: res?.data?.amount,
      offerId: res?.data?.usedOffers?.[0]?.offerId,
      planId: planId,
      pretaxAmount:res?.data?.pretaxAmount,
      taxAmount: res?.data?.taxAmount
    }
    publishDiscountData(data)
    return data
  }).catch((e) => {
    logger(e, 'error')
    return e
    // pubsub.publish('isLoading', false)
  })
}